module.exports = __webpack_public_path__ + "static/img/payment-mastercard.e6a729fb.svg";